import { LoyaltyTier, TierNames } from "../contexts/loyalty/types";
import { isWhiskymofo } from "./is-page";

export const BIG_COMMERCE_CART_ID_COOKIE = "vm-bigcommerce-cart-id";
export const GUEST_CART_EMAIL_COOKIE = "vm-guest-cart-email";

export const GUEST_CHECKOUT_PATH = "/guest-checkout/";

export const MARKET_COUNTRIES = {
  AU: "Australia",
  SG: "Singapore",
};

export const MARKET_AUDIENCE = {
  ALL: "AU, NZ, SG",
  EXCEPTSG: "AU, NZ",
  SG: "SG",
  AU: "AU",
};

export enum EDevice {
  BOTH = "both",
  DESKTOP = "desktop",
  MOBILE = "mobile",
}

export const DEVICE = {
  BOTH: EDevice.BOTH,
  DESKTOP: EDevice.DESKTOP,
  MOBILE: EDevice.MOBILE,
};

export const INVALID_ADDRESS_MSG =
  "Something wrong with the address, please check suburb, postcode or state if they are matching";

export const PROMOTIONS_BANNER_TYPES = {
  UPSELL: "upsell",
  ELIGIBLE: "eligible",
  APPLIED: "applied",
};

export const loyaltyTierNames: TierNames = {
  GREEN: "GREEN",
  SILVER: "SILVER",
  GOLD: "GOLD",
  BLACK: "BLACK",
  FOUNDERS: "FOUNDERS",
};

export const loyaltyTiers: LoyaltyTier[] = [
  loyaltyTierNames.GREEN,
  loyaltyTierNames.SILVER,
  loyaltyTierNames.GOLD,
  loyaltyTierNames.BLACK,
  loyaltyTierNames.FOUNDERS,
];

export const refundStatus = [4, 14];

export const discountDisplays = {
  percent: "percentage",
  dollar: "dollar_value",
};

export const DEFAULT_SEARCH_TITLE = isWhiskymofo ? "All Spirits" : "All Wines";
export const DEFAULT_SEARCH_PLACEHOLDER = isWhiskymofo
  ? "Search for whisky…"
  : "Search for wine…";
export const DEFAULT_SEARCH_FLAVOUR_TITLE = isWhiskymofo
  ? "The best f@%*ng whisky deals on the planet."
  : "The best f@%*ng wine deals on the planet.";
export const DEFAULT_SEARCH_FLAVOUR_TEXT = isWhiskymofo
  ? "No bowties, no BS. Good whisky, the most epic deals and happiness, guaranteed."
  : "No bowties, no BS. Good wines, the most epic deals and happiness, guaranteed.";

export const DEFAULT_EXAMPLE_SEARCHES = isWhiskymofo
  ? [
      "Single Malt Scotch",
      "Bourbon Whisky",
      "Premium Gin",
      "Aged Rum",
      "Tequila Blanco",
      "Search for whisky^1000.^1000.^1000.",
    ]
  : [
      "Barossa Shiraz",
      "French reds",
      "French wines",
      "Pinot Noir",
      "Search for wines^1000.^1000.^1000.",
    ];

export const VM_WM_APP_URL = process.env.GATSBY_VM_WM_APP_URL;
const isVmWmAppUrlEmpty = !VM_WM_APP_URL || VM_WM_APP_URL.trim() === "";
export const SHOW_TOGGLE = !isVmWmAppUrlEmpty
  ? process.env.GATSBY_SHOW_TOGGLE === "true"
  : false;
